import { NavLink } from "react-router";

import { captureEvent } from "components/posthog/customEventCapture";
import { MenuItem } from "models/header/menuItems";
import { useGlobalContext } from "app/store/GlobalContext";

import "./MainMenu.scss";

type Props = {
  menuItems: MenuItem[];
};

export default function MainMenu({ menuItems }: Props) {
  const { handleNavigation } = useGlobalContext();

  return (
    <div className="headerMenu">
      <nav>
        <ul>
          {menuItems.map((item, index) => {
            if (item.component) {
              return (
                <li
                  key={index}
                  title={item.info}
                  onClick={() => {
                    captureEvent(item.title ?? "menuItem");
                  }}
                >
                  <div>{item.component}</div>
                </li>
              );
            }

            return (
              <li key={index} title={item.info}>
                <NavLink
                  to={item.href ?? ""}
                  onClick={(e) => {
                    handleNavigation({
                      url: item.href ?? "",
                      eventTitle: item.title ?? "menuItem",
                      e: e,
                    });
                  }}
                >
                  {item.title}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
